export const ConsumerPostSubmissionLoadingUat = {
  spinner: 'workflow.consumerPostSubmissionLoading.spinner'
}
